























import { defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';

import { IconArrowRight } from '@/icons';
import type { Disclaimer } from '@/graphql/generated';

export default defineComponent({
  name: 'ShowsDisclaimer',
  components: {
    IconArrowRight,
  },
  props: {
    disclaimer: {
      type: Object as PropType<Disclaimer>,
      required: true,
    },
  },
});
